var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPastTestKit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5V4C17 2.89543 16.1046 2 15 2H4C2.89543 2 2 2.89543 2 4V18C2 19.1046 2.89543 20 4 20H8",
    stroke: "#262626",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7998 14C7.24155 14 7.59948 14.3581 7.59961 14.7998C7.59961 15.2416 7.24163 15.5996 6.7998 15.5996H4.7998C4.35809 15.5995 4 15.2416 4 14.7998C4.00013 14.3582 4.35817 14.0001 4.7998 14H6.7998ZM7.7998 11C8.24155 11 8.59948 11.3581 8.59961 11.7998C8.59961 12.2416 8.24163 12.5996 7.7998 12.5996H4.7998C4.35809 12.5995 4 12.2416 4 11.7998C4.00013 11.3582 4.35817 11.0001 4.7998 11H7.7998ZM10.293 8C10.7347 8 11.0936 8.35807 11.0938 8.7998C11.0938 9.24163 10.7348 9.59961 10.293 9.59961H4.7998C4.35807 9.5995 4 9.24157 4 8.7998C4.00011 8.35813 4.35813 8.00011 4.7998 8H10.293ZM13.5898 5C14.0315 5.00016 14.3895 5.35817 14.3896 5.7998C14.3896 6.24153 14.0315 6.59945 13.5898 6.59961H4.7998C4.35807 6.5995 4 6.24157 4 5.7998C4.00011 5.35813 4.35813 5.00011 4.7998 5H13.5898Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10C19.0912 10 22 12.9088 22 16.5C22 20.0912 19.0912 23 15.5 23C11.9088 23 9 20.0912 9 16.5C9 12.9088 11.9088 10 15.5 10ZM15.5 11.2998C12.6335 11.2998 10.2998 13.6335 10.2998 16.5C10.2998 19.3665 12.6335 21.7002 15.5 21.7002C18.3665 21.7002 20.7002 19.3665 20.7002 16.5C20.7002 13.6335 18.3665 11.2998 15.5 11.2998ZM16.2998 16.373L17.5977 18.2041L16.9443 18.666L16.292 19.1289L14.8477 17.0898L14.7002 16.8818V12.8887H16.2998V16.373Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastTestKit);
export default __webpack_public_path__ + "static/media/pastTestKit.7f087975e505d28fbf980ff1bcf1d5fd.svg";
export { ForwardRef as ReactComponent };